import React from 'react';

/**
 * Skip Navigation component for keyboard users
 * Provides quick access to main content areas
 */
const SkipNavigation: React.FC = () => {
  return (
    <nav aria-label="Skip navigation" className="sr-only focus-within:not-sr-only">
      <div className="fixed top-4 left-4 z-50 bg-primary text-white px-4 py-2 rounded-lg shadow-lg focus:outline-none">
        <a
          href="#main-content"
          className="text-white hover:text-gray-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-primary"
          onClick={(e) => {
            e.preventDefault();
            const mainContent = document.getElementById('main-content');
            if (mainContent) {
              mainContent.focus();
              mainContent.scrollIntoView({ behavior: 'smooth' });
            }
          }}
        >
          Skip to main content
        </a>
      </div>
    </nav>
  );
};

export default SkipNavigation;